const URL = `https://roundup-prod-production.up.railway.app/api`;

export const api = {
  register: `${URL}/client/round-up/user/register`,
  consent: `${URL}/client/round-up/user/consent`,
  checkConsent: `${URL}/client/round-up/user/check-consent`,
  findJobs: `${URL}/handlers/basiq/find-jobs`,
  checkJob: `${URL}/client/round-up/user/check-job`,
  retrieveAccounts: `${URL}/client/round-up/user/retrieve-accounts`,
  accounts: `${URL}/client/round-up/user/accounts`,
  setRoundUpAccounts: `${URL}/client/round-up/user/set-roundup-accounts`,
  registerFunding: `${URL}/client/round-up/user/register-funding`,
  setRoundUpAmount: `${URL}/client/round-up/user/set-roundup-amount`,
  setWeeklyLimit:  `${URL}/client/round-up/user/set-weekly-limit`,
  setPaused: `${URL}/client/round-up/user/set-pause`,
   
  onboardingComplete: `${URL}/client/round-up/user/onboarding-complete`,

  manageConsent: `${URL}/client/round-up/user/manage-consent`,
  getUser: `${URL}/client/round-up/user/get-user`,
  retrieveTotalDebits: `${URL}/client/round-up/user/retrieve-total-debits`,
  debitsYTD: `${URL}/client/round-up/user/debits-ytd`,
  debitsAllTime: `${URL}/client/round-up/user/debits-total`,
  retrieveHistory: `${URL}/client/round-up/user/retrieve-history`,

  retrieveClubs: `${URL}/clubs/retrieve`,

  retrieveLinkedSavings: `${URL}/client/round-up/user/linked-savings`,
  submitSavingsAccount: `${URL}/client/round-up/user/submit-savings-account`,
  setSavingsAccount: `${URL}/client/round-up/user/set-savings-account`,
  
  updateRoundUpAccounts: `${URL}/client/round-up/user/update-roundup-accounts`,
  donateNow: `${URL}/client/round-up/user/donate-now`,
  updateFundingAccount: `${URL}/client/round-up/user/update-funding-account`,
  findClub: `${URL}/clubs/club`,

  

}


